module.exports = __webpack_public_path__ + "9005f94d82f826279227e4ad52fe0c22.MP3";